import { render } from "./IndustryView.vue?vue&type=template&id=4e55e6f0&scoped=true"
import script from "./IndustryView.vue?vue&type=script&lang=js"
export * from "./IndustryView.vue?vue&type=script&lang=js"

import "./IndustryView.vue?vue&type=style&index=0&id=4e55e6f0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e55e6f0"]])

export default __exports__